import BaseApi from "./baseAPI";

class LectureAPI extends BaseApi{
  get entity() {
    return {
      route: `${this.getCourseId()}/lectures`,
      name: 'المحاضرة'
    }
  }

  updateBody(id, body){
    return new Promise((resolve, reject) => {
      return this.request.put(`${this.entity.route}/${id}/body`, {body: body})
          .then(response => resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
    })
  }
}

export default new LectureAPI()
